export const removeOverlayFromDocument = (target) => {
  const documentOverlay = document.querySelector('.documentOverlay')
  if (documentOverlay) {
    documentOverlay.classList.remove('documentOverlay-active')
  }
  const targetElement = document.querySelector(target)
  if (targetElement) {
    targetElement.classList.remove('documentOverlayElement-focus')
  }
}
